import { atom, useAtom } from 'jotai';

const locationFilterModalAtom = atom<boolean | undefined>(false);

export function useLocationFilterModalAtom() {
  const [locationFilterModal, setLocationFilterModal] = useAtom(locationFilterModalAtom);

  return { locationFilterModal, setLocationFilterModal };
}
